import { DiscardableModel } from './DiscardableModel';
import { ErroredModel } from './ErroredModel';
import { PaginationMeta } from './pagination';

export enum EmployeeTimeOffMode {
  FULL = 'full',
  WEEKLY = 'weekly',
}

export type EmployeeTimeOff = ErroredModel &
  DiscardableModel & {
    uuid: string;
    employee_uuid: string;
    employee_display_name: string;
    start_date: string;
    end_date: string;
    mode: EmployeeTimeOffMode;
    approved: boolean;
    details?: number[];
  };

export type EmployeeTimeOffResponse = {
  data: EmployeeTimeOff[];
  meta: PaginationMeta;
};

export type EmployeeTimeOffAvailabilityRecord = {
  uuid: string;
  mode: EmployeeTimeOffMode;
  approved: boolean;
};

export type EmployeeTimeOffAvailabilityResponse = Record<string, Record<string, EmployeeTimeOffAvailabilityRecord[]>>;

export enum AvailabilityStatus {
  AVAILABLE = 'available',
  REQUESTED_OFF = 'requested_off',
  UNAVAILABLE = 'unavailable',
}
